import type { CategoryWithMonthData } from '../../types/category';
import type { Account } from '../../types/account';

export interface CategorySplitWithData {
  category_id: string;
  amount: number;
  categoryName: string;
  parentName?: string;
  remainingAllocation?: number;
  isGoal?: boolean;
  goalTargetMonth?: string | null;
  displayLabel?: string;
}

export interface TransactionFormData {
  id: string; // Unique ID for React key (not DB id)
  dbId?: string; // Actual database ID for edit mode
  type: 'expense' | 'income' | 'transfer';
  amount: number;
  categorySplits: CategorySplitWithData[];
  selectedAccount: string;
  fromAccount: string;
  toAccount: string;
  description: string;
  date: string;
  selectedBudgetMonthPlan: string;
  isExpanded: boolean;
  hasError: boolean;
  errorMessage?: string;
}

export interface TransactionFormProps {
  transaction: TransactionFormData;
  index: number;
  mode: 'add' | 'edit';
  isOnlyCard: boolean;
  accounts: Account[];
  allMonthPlans: { id: string; month: string }[];
  budgetMonthCategories: CategoryWithMonthData[];
  loadingBudgetCategories: boolean;
  formatMoney: (value: number) => string;
  formatMonth: (monthStr: string) => string;
  onUpdate: (index: number, updates: Partial<TransactionFormData>) => void;
  onRemove: (index: number) => void;
  onToggleExpand: (index: number) => void;
  onBudgetMonthChange: (index: number, monthPlanId: string) => void;
  // Desktop only: callback to create multiple rows from category selection
  onCreateRowsForCategories?: (baseTransaction: TransactionFormData, categoryIds: string[]) => void;
}

export const createEmptyTransaction = (budgetMonthPlanId: string): TransactionFormData => ({
  id: crypto.randomUUID(),
  type: 'expense',
  amount: 0,
  categorySplits: [],
  selectedAccount: '',
  fromAccount: '',
  toAccount: '',
  description: '',
  date: new Date().toISOString().split('T')[0],
  selectedBudgetMonthPlan: budgetMonthPlanId,
  isExpanded: true,
  hasError: false,
});
